import React from "react";
import { Info } from "lucide-react";

/**
 * Required wherever earning potential is discussed. Keeps the affiliate
 * program copy FTC-compliant and prevents implied income guarantees.
 *
 * Props:
 *   variant: "inline" (tiny note) | "block" (boxed callout, default)
 *   testIdSuffix: optional disambiguator when multiple disclaimers exist on
 *                 a single page (e.g. "home" vs "zone")
 */
export default function ComplianceDisclaimer({ variant = "block", testIdSuffix = "default" }) {
  const text = (
    <>
      Earnings depend on individual effort, network activity, and ecosystem volume.
      Commissions follow current tier rules and require approval before payout.
      The Lifted Affiliate Program does not guarantee income — results vary.
      See <a href="/affiliate-zone/terms" className="underline hover:text-lifted-green">program terms</a>.
    </>
  );

  if (variant === "inline") {
    return (
      <p
        data-testid={`compliance-disclaimer-${testIdSuffix}`}
        className="text-[0.6rem] text-lifted-mute leading-snug mt-2"
      >
        {text}
      </p>
    );
  }
  return (
    <div
      data-testid={`compliance-disclaimer-${testIdSuffix}`}
      className="glass-panel p-4 mt-4 flex items-start gap-3 text-[0.7rem] text-lifted-dim leading-relaxed"
    >
      <Info className="h-4 w-4 text-lifted-green shrink-0 mt-0.5" aria-hidden="true" />
      <p>{text}</p>
    </div>
  );
}
